// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"5bef1cf1","535":"00141355"}[chunkId] + ".chunk.css";
};